<span [class.font-weight-lighter]="lighter" class="small">{{userName}}</span>
